export enum SmileyType {
  ANGRY = 'smiley-angry',
  DISSATISFIED = 'smiley-dissatisfied',
  NEUTRAL = 'smiley-neutral',
  SMILING = 'smiley-smiling',
  LAUGHING = 'smiley-laughing',
}
